import { getAuthorization } from '../models/account';


export const appAuth = {
  authorization: null,
  isAuthenticated() {
    return this.authorization != null
  },
  checkAuthorization(cb) {
    let authorization = getAuthorization();
    if ( authorization && authorization.refreshToken !== null ) {
      this.authorization = authorization;
    } else {
      this.authorization = null;
    }
    setTimeout(cb, 100);
  },
  signout(cb) {
    this.authorization = null;
    setTimeout(cb, 100);
  }
};
